import { render } from "react-dom";
import ApolloProvider from "ApolloProvider";

render(ApolloProvider, document.getElementById("root"));
